import { inject, Injectable } from '@angular/core';
import { AuthStore } from '../auth.store';
import { AuthService } from '../auth.service';
import { catchError, of, tap } from 'rxjs';
import { ErrorFacade } from '../../error/error.facade';

@Injectable({ providedIn: 'root' })
export class AuthStartupFacade {
  readonly #authService = inject(AuthService);
  readonly #authStore = inject(AuthStore);
  readonly #errorFacade = inject(ErrorFacade);

  #handleUserSession() {
    return this.#authService.getUser().pipe(
      tap((user) => this.#authStore.updateUser(user)),
      catchError((appError) => {
        this.#errorFacade.captureError(appError);
        return of(null);
      })
    );
  }

  restoreState() {
    return this.#handleUserSession();
  }
}
